import React, { useState } from 'react';
import consultationImage from '../assets/img/contact_form.png';

const ConsultationForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    mobile: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formEndpoint = 'https://formspree.io/f/xldjwjzy'; // Formspree endpoint

    try {
      const response = await fetch(formEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('Form submitted successfully!');
        setFormData({ firstName: '', mobile: '', email: '', message: '' });
      } else {
        setStatus('Failed to submit the form. Please try again.');
      }
    } catch (error) {
      setStatus('Error submitting the form. Please check your network.');
    }
  };

  return (
    <section className="consultation-form pb-4">
      <div className="container">
        <div className="card shadow-lg w-100">
          <div className="row g-0">
            <h2 className="text-start mb-4 montserrat-heading fw-bold">Book a Appointment</h2>
            <p className="text-start mb-4 poppins-text fw-bold">Let us know how to get back to you.</p>

            {/* Form Side */}
            <div className="col-md-6 p-4" id="ConsultationForm">
              <h4 className="mb-3 poppins-text">Fill out the form</h4>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control poppins-text"
                    name="firstName"
                    placeholder="First name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control poppins-text"
                    name="mobile"
                    placeholder="Mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control poppins-text"
                    name="email"
                    placeholder="E-mail"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <textarea
                    className="form-control poppins-text"
                    name="message"
                    placeholder="Write a message..."
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <div className="text-center">
                  <button type="submit" className="btn gradient-btn poppins-text">Submit</button>
                  {status && <p className="mt-3">{status}</p>}
                </div>
              </form>
            </div>

            {/* Image Side */}
            <div className="col-md-6">
              <img
                src={consultationImage}
                alt="Consultation"
                className="img-fluid rounded-start"
                style={{ objectFit: 'cover', height: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationForm;
